import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });

// Materials
const getMaterials = () => axios.get(`${API_URL}/api/packaging/materials`, auth()).then(r => r.data);
const createMaterial = (data) => axios.post(`${API_URL}/api/packaging/materials`, data, auth()).then(r => r.data);
const updateMaterial = (id, data) => axios.put(`${API_URL}/api/packaging/materials/${id}`, data, auth()).then(r => r.data);
const deleteMaterial = (id) => axios.delete(`${API_URL}/api/packaging/materials/${id}`, auth()).then(r => r.data);

// Receiving logs
const getReceiving = (params = {}) => axios.get(`${API_URL}/api/packaging/receiving`, { ...auth(), params }).then(r => r.data);
const createReceiving = (data) => axios.post(`${API_URL}/api/packaging/receiving`, data, auth()).then(r => r.data);
const updateReceiving = (id, data) => axios.put(`${API_URL}/api/packaging/receiving/${id}`, data, auth()).then(r => r.data);
const deleteReceiving = (id) => axios.delete(`${API_URL}/api/packaging/receiving/${id}`, auth()).then(r => r.data);

// Adjustments
const getAdjustments = (params = {}) => axios.get(`${API_URL}/api/packaging/adjustments`, { ...auth(), params }).then(r => r.data);
const createAdjustment = (data) => axios.post(`${API_URL}/api/packaging/adjustments`, data, auth()).then(r => r.data);
const deleteAdjustment = (id) => axios.delete(`${API_URL}/api/packaging/adjustments/${id}`, auth()).then(r => r.data);

// Physical inventory count
const getPhysicalCountDraftSheet = () => axios.get(`${API_URL}/api/packaging/physical-counts/draft-sheet`, auth()).then(r => r.data);
const getPhysicalCounts = () => axios.get(`${API_URL}/api/packaging/physical-counts`, auth()).then(r => r.data);
const getPhysicalCount = (id) => axios.get(`${API_URL}/api/packaging/physical-counts/${id}`, auth()).then(r => r.data);
const submitPhysicalCount = (data) => axios.post(`${API_URL}/api/packaging/physical-counts`, data, auth()).then(r => r.data);
const deletePhysicalCount = (id) => axios.delete(`${API_URL}/api/packaging/physical-counts/${id}`, auth()).then(r => r.data);

// Cost history
const getMaterialCosts = (materialId) => axios.get(`${API_URL}/api/packaging/materials/${materialId}/costs`, auth()).then(r => r.data);
const addCostEntry = (materialId, data) => axios.post(`${API_URL}/api/packaging/materials/${materialId}/costs`, data, auth()).then(r => r.data);

// Summary
const getSummary = () => axios.get(`${API_URL}/api/packaging/summary`, auth()).then(r => r.data);

const packagingService = {
  getMaterials, createMaterial, updateMaterial, deleteMaterial,
  getReceiving, createReceiving, updateReceiving, deleteReceiving,
  getAdjustments, createAdjustment, deleteAdjustment,
  getPhysicalCountDraftSheet, getPhysicalCounts, getPhysicalCount, submitPhysicalCount, deletePhysicalCount,
  getMaterialCosts, addCostEntry,
  getSummary,
};

export default packagingService;
